<h1 mat-dialog-title>{{ 'login.recover_password.title.new_password' | translate }}</h1>

<div mat-dialog-content>
    <dr-password [idPrefix]="idPrefix"
                 (updatePassword)="password = $event">
    </dr-password>
</div>

<div mat-dialog-actions align="center">
    <div class="col-sm-6 offset-sm-6 no-gutters pr-0 mt-3 mb-3">
        <button id="{{idPrefix}}btn.change_password"
                mat-raised-button
                class="full-width"
                color="accent"
                tabindex="3"
                (click)="savePassword()"
                [disabled]="!password">
            {{ 'login.recover_password.btn.confirm' | translate }}
        </button>
    </div>
</div>
